module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/receipt/receipt-page-search-receipt-issuer/receipt-page-search-receipt-issuer.component.scss
// module id = ./src/app/admin/receipt/receipt-page-search-receipt-issuer/receipt-page-search-receipt-issuer.component.scss
// module chunks = main